<div class="item text-center">
  {{ field.content }}
</div>
